module.exports = __webpack_public_path__ + "static/media/Freeze_gland.5ba18f4c.png";